// extracted by mini-css-extract-plugin
export default {"custom":"styles_custom__iq110"};